import React, { useMemo, useEffect, useRef } from 'react';
import { Select, Form, TreeSelect } from 'antd';
import useCagegory from '@/hooks/useCategory';

const { Option } = Select;

function FieldCategoryName({ category, value, onChange, categoryData }) {
  // 需要cagegoryName用来展示在详情页面之类的地方
  const categoryName = useMemo(() => {
    if (!category || !category.length) return '';
    const categoryNameArr = [];
    if (categoryData && categoryData.values.length) {
      for (var i = 0, length = categoryData.values.length; i < length; i++) {
        if (category.indexOf(categoryData.values[i].categoryId) !== -1) {
          categoryNameArr.push(categoryData.values[i].categoryName);
        }
      }
    }
    return categoryNameArr.toString();
  }, [category, categoryData]);

  useEffect(() => {
    categoryName && onChange(categoryName);
    onChange(categoryName);
  }, [categoryName, onChange]);

  return null;
}

function Category(props) {
  const [categoriesLoadStatus, categories] = useCagegory();
  const categoryData = { loading: categoriesLoadStatus, values: categories };

  const {
    required,
    placeholder = '请选择主推品类',
    label = '主推品类',
    name = 'category',
    withCategoryName = true,
    categoryType = 'part',
    rules = [
      {
        required: true,
        message: '主推品类不能为空',
      },
    ],
  } = props;

  return (
    <>
      <Form.Item label={label} name={name} rules={required ? rules : null}>
        {categoryType === 'all' ? (
          <TreeSelectCatogory option={categories} placeholder={placeholder} />
        ) : (
          <Select
            allowClear
            mode="multiple"
            optionFilterProp="children"
            filterOption={(input, option) => option.children.indexOf(input) >= 0}
            loading={categoriesLoadStatus}
            placeholder={placeholder}
          >
            {categories.map((item) => (
              <Option key={item.categoryId} value={item.categoryId}>
                {item.categoryName}
              </Option>
            ))}
          </Select>
        )}
      </Form.Item>
      {!withCategoryName ? null : (
        <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues.category !== curValues.category}>
          {({ getFieldValue }) => {
            return (
              <Form.Item name="categoryName" noStyle>
                <FieldCategoryName category={getFieldValue('category')} categoryData={categoryData} />
              </Form.Item>
            );
          }}
        </Form.Item>
      )}
    </>
  );
}

function TreeSelectCatogory({ value, onChange, option, placeholder }) {
  const listRef = useRef(null);
  const treeData = useMemo(() => {
    if (!option || !option.length) {
      return [];
    }
    const arr = [];
    option.map((item) => {
      arr.push({
        key: item.categoryId,
        title: item.categoryName,
        value: item.categoryId,
      });
    });
    return [
      {
        value: '全部行业',
        title: '全部行业',
        key: '全部行业',
        children: arr,
      },
    ];
  }, [option]);

  function handleOnChange(value, label) {
    if (value.length === 1 && value[0] === '全部行业') {
      const category = [];
      treeData[0].children.map((item) => category.push(item.value));
      onChange(category);
    } else {
      onChange(value);
    }
  }

  return (
    <div ref={listRef}>
      <TreeSelect
        getPopupContainer={() => listRef.current}
        treeDefaultExpandAll
        showCheckedStrategy="SHOW_PARENT"
        placeholder={placeholder}
        treeCheckable
        allowClear
        value={value}
        treeData={treeData}
        showSearch
        filterTreeNode={(inputValue, treeNode) => treeNode.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0}
        onChange={handleOnChange}
      />
    </div>
  );
}

export default Category;
